import React from "react";
import {
  Box, Typography, Paper, TextField, Button, Grid,
  Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderIcon from "@mui/icons-material/Folder";
import SelectConAggiunta from "../SelectConAggiunta";

export default function SezioneBase({ form, handleChange, handleDurataGiorni, handleGiornata, clienti, loadingClienti, aggiungiCliente, tipologieEvento, loadingTipologie, aggiungiTipologia, onCreaDriveManuale }) {
  return (
    <Accordion defaultExpanded elevation={1} sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#E6F1FB" }}>
        <Typography fontWeight="bold">Informazioni base</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12}>
            <TextField fullWidth label="Titolo" value={form.titolo}
              onChange={(e) => handleChange("titolo", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Durata (ore)" type="number" value={form.durata}
              onChange={(e) => handleChange("durata", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Durata (giorni)" type="number"
              value={form.durataGiorni}
              onChange={(e) => handleDurataGiorni(e.target.value)}
              inputProps={{ min: 1 }} />
          </Grid>

          {form.durataGiorni <= 1 ? (
            <>
              <Grid item xs={12} md={3}>
                <TextField fullWidth label="Data inizio" type="date" value={form.dataInizio}
                  onChange={(e) => handleChange("dataInizio", e.target.value)}
                  InputLabelProps={{ shrink: true }} />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField fullWidth label="Ora inizio" type="time" value={form.oraInizio}
                  onChange={(e) => handleChange("oraInizio", e.target.value)}
                  InputLabelProps={{ shrink: true }} />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField fullWidth label="Data fine" type="date" value={form.dataFine}
                  onChange={(e) => handleChange("dataFine", e.target.value)}
                  InputLabelProps={{ shrink: true }} />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField fullWidth label="Ora fine" type="time" value={form.oraFine}
                  onChange={(e) => handleChange("oraFine", e.target.value)}
                  InputLabelProps={{ shrink: true }} />
              </Grid>
            </>
          ) : (
            form.giornate.map((giornata, index) => (
              <Grid item xs={12} key={index}>
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Typography variant="body2" fontWeight="bold" mb={1} color="primary">
                    Giorno {index + 1}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <TextField fullWidth label="Data inizio" type="date"
                        value={giornata.dataInizio}
                        onChange={(e) => handleGiornata(index, "dataInizio", e.target.value)}
                        InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField fullWidth label="Ora inizio" type="time"
                        value={giornata.oraInizio}
                        onChange={(e) => handleGiornata(index, "oraInizio", e.target.value)}
                        InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField fullWidth label="Data fine" type="date"
                        value={giornata.dataFine}
                        onChange={(e) => handleGiornata(index, "dataFine", e.target.value)}
                        InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField fullWidth label="Ora fine" type="time"
                        value={giornata.oraFine}
                        onChange={(e) => handleGiornata(index, "oraFine", e.target.value)}
                        InputLabelProps={{ shrink: true }} />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ))
          )}

          <Grid item xs={12} md={4}>
            <SelectConAggiunta label="Tipo evento" value={form.tipoEvento || ""}
              onChange={(v) => handleChange("tipoEvento", v)}
              items={[
                { id: "online", nome: "Online" },
                { id: "presenza", nome: "In presenza" },
                { id: "ibrido", nome: "Ibrido" },
              ]}
              loading={false}
              onAggiungi={() => {}} />
          </Grid>
          <Grid item xs={12} md={8}>
            <SelectConAggiunta label="Tipologia evento" value={form.tipologiaEvento || []}
              onChange={(v) => handleChange("tipologiaEvento", v)}
              items={tipologieEvento} loading={loadingTipologie}
              onAggiungi={aggiungiTipologia} multiple />
          </Grid>

          <Grid item xs={12}>
            <SelectConAggiunta label="Cliente" value={form.clienteId || ""}
              onChange={(v) => handleChange("clienteId", v)}
              items={clienti} loading={loadingClienti}
              onAggiungi={aggiungiCliente} />
          </Grid>

          <Grid item xs={12}>
            <TextField fullWidth multiline rows={3} label="Descrizione"
              value={form.descrizione}
              onChange={(e) => handleChange("descrizione", e.target.value)} />
          </Grid>

          <Grid item xs={12}>
            {form.cartellaDrive ? (
              <Box>
                <Typography variant="caption" color="text.secondary">Cartella Drive</Typography>
                <Box mt={0.5}>
                  <Button variant="outlined" size="small" startIcon={<FolderIcon />}
                    href={form.cartellaDrive} target="_blank" rel="noopener noreferrer">
                    Apri cartella Drive
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box>
                <TextField fullWidth label="Cartella Drive (URL)" value=""
                  InputProps={{ readOnly: true }}
                  helperText="Verrà creata automaticamente al salvataggio" />
                {form.stato !== "lead" && form.titolo && form.clienteId && (
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<FolderIcon />}
                    onClick={onCreaDriveManuale}
                    sx={{ mt: 1 }}
                  >
                    Crea cartella Drive manualmente
                  </Button>
                )}
              </Box>
            )}
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField fullWidth label="Ore Algores" type="number" value={form.oreAlgores}
              onChange={(e) => handleChange("oreAlgores", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField fullWidth label="Ore Collaboratori" type="number" value={form.oreCollaboratori}
              onChange={(e) => handleChange("oreCollaboratori", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField fullWidth label="Importo di vendita (€)" type="number" value={form.importoVendita}
              onChange={(e) => handleChange("importoVendita", e.target.value)} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}